import Open from '../../blocks.02-common/open/open';

const Events = {
    INIT: 'init.history.cookies',
    HIDE: 'hide.history.panel',
    UPDATE_COOKIES: 'cookies.update',
    SEND_VALUE_TO_SEARCH: 'send.value.from.history',
    SUBMIT: 'iv.search',
    CLOSE_DROPDOWN: 'close.dropdown.event',
    SHOW_HISTORY: 'show.iv.searchPanelHistory',
    HIDE_HISTORY: 'hide.iv.searchPanelHistory',
};

const Selectors = {
    SEARCH_PANEL: '.search-panel',
};

class Search {
    constructor(elem) {
        this.$block = $(elem);
        this.$input = this.$block.find('.search__input');
        this.$searchPanel = this.$block.find(Selectors.SEARCH_PANEL);
        this.input = document.querySelector('.search__input');
        this.action = this.$block.data('action');
        this.maxSymbols = this.$block.data('max-symbols');
        this.historyListName = this.$block.data('history') || 'HISTORY_LIST';
        this.maxCookies = this.$block.data('max');
        this.isFormSubmited = false;
        this.minLength = parseInt(this.$block.data('minLength') || 3);
        this.historyList = [];

        this.submitWithData = this.submitWithData.bind(this);
        this.submitWithDataManual = this.submitWithDataManual.bind(this);
        this.addHistoryItemOnSubmit = this.addHistoryItemOnSubmit.bind(this);
        this.updateHistoryListFromHistory = this.updateHistoryListFromHistory.bind(this);
        this.toggleOpen = this.toggleOpen.bind(this);

        this.init();

        this.$block
          .on('change keyup', '.search__input', (event) => this.change(event.target.value))
          .on('focus', '.search__input', (e) => {
              if (!e.target.closest('.search')) return;
              this.toggleHistoryPanel(this.$input.val().length <= this.minLength && this.historyList.length);
              this.toggleOpen(true);
          });

        $(document)
          .on('click', (e) => {
            if (
              !$(e.target).closest('.search').length
              && !$(e.target).closest('.search-panel-backdrop').length
              && !$(e.target).hasClass('history__clear')
            ) {
                this.toggleOpen(false);
            }
        });
    }

    init() {
        this.initHistoryList();
        this.$block.on('submit', this.addHistoryItemOnSubmit);
        this.$block.on(Events.SUBMIT, this.submitWithDataManual);
        document.addEventListener(Events.UPDATE_COOKIES, this.updateHistoryListFromHistory);
        this.searchFromHistoryListener();
        this.hideHistoryPanelListener();

        this.toggleOpenListeners();
    }

    initHistoryList() {
        const oldHistoryList = JSON.parse(localStorage.getItem(this.historyListName) || '[]');
        if (!oldHistoryList.length) {
            return;
        }
        this.historyList = oldHistoryList.filter((item) => {
            return item.expired < new Date().getTime() + 2629800000;
        });
    }

    updateHistoryListFromHistory(e) {
        this.historyList = [...e.detail];
        localStorage.setItem(this.historyListName, JSON.stringify(this.historyList));
    }

    toggleOpenListeners() {
        this.$searchPanel.on('hide.iv.open', () => this.toggleOpenClass(false));
        this.$searchPanel.on('show.iv.open', () => this.toggleOpenClass(true));
    }

    toggleHistoryPanel(open) {
        open ? this.$searchPanel.trigger(Events.SHOW_HISTORY) : this.$searchPanel.trigger(Events.HIDE_HISTORY);
    }

    toggleOpenClass(open) {
        open ? this.$block.addClass('search_open') : this.$block.removeClass('search_open');
    }

    toggleOpen(open) {
        open ? Open.open(this.input) : Open.close(this.input);
    }

    change(query) {
        if (query.length <= this.minLength && this.historyList.length) {
            this.toggleHistoryPanel(true);
        }
        if (query.length > this.minLength) {
            this.toggleHistoryPanel(false);
        }

        if (process.env.NODE_ENV === 'development') {
            query.length > this.minLength
              ? this.$searchPanel.trigger('show.iv.searchPanelSuggestions')
              : this.$searchPanel.trigger('hide.iv.searchPanelSuggestions');
        }
    }

    hideHistoryPanelListener() {
        document.addEventListener(Events.CLOSE_DROPDOWN, () => this.toggleHistoryPanel(false));
    }

    searchFromHistoryListener() {
        document.addEventListener(Events.SEND_VALUE_TO_SEARCH, this.submitWithData);
    }

    submitWithData(event) {
        if (this.isFormSubmited) {
            return;
        }
        this.isFormSubmited = true;
        this.$input.val(event.detail);
        this.$input.trigger('change');
        this.addItemToHistory(event.detail);
    }

    submitWithDataManual() {
        if (this.isFormSubmited) {
            return;
        }
        if (!this.$input.val() || !this.$input.val().length || this.$input.val().length > Number(this.maxSymbols) || this.$input.val().replace(/ /g, '') === '') {
            this.$block[0].submit();
            return;
        }
        this.isFormSubmited = true;
        this.addItemToHistory(this.$input.val());
    }

    addItemToHistory(value) {
        this.historyList.push(this.getProcessedNewHistoryItem(value));
        this.processNewHistoryList();
        if (this.historyList.length > this.maxCookies) this.historyList.shift();
        localStorage.setItem(this.historyListName, JSON.stringify(this.historyList));

        this.$block[0].submit();
    }

    processNewHistoryList() {
        const listForCompare = [];
        let copiedItem = null;
        this.historyList = this.historyList.filter((item) => {
            if (listForCompare.includes(item.text)) {
                copiedItem = item;
                return false;
            }
            listForCompare.push(item.text);
            return true;
        });
        if (copiedItem) {
            this.historyList = this.historyList.filter((item) => item.text !== copiedItem.text);
            this.historyList.push(copiedItem);
        }
    }

    getProcessedNewHistoryItem(historyItem) {
        const newHistoryItem = {};
        newHistoryItem.text = historyItem;
        newHistoryItem.expired = new Date().getTime() + 2629800000;

        return newHistoryItem;
    }

    addHistoryItemOnSubmit(event) {
        event && event.preventDefault();
        if (this.isFormSubmited) return;
        if (!this.$input.val().length || this.$input.val().length > Number(this.maxSymbols) || this.$input.val().replace(/ /g, '') === '') {
            this.$block[0].submit();
            return;
        }


        this.isFormSubmited = true;
        const newHistoryItemValue = this.$input.val();
        this.addItemToHistory(newHistoryItemValue);

        this.$block[0].submit();
    }
}

[...document.getElementsByClassName('search')].forEach((elem) => new Search(elem));
